import React, { useContext } from 'react';
import { GlobalContext } from '../../reducers/global';
import langs from '../../translations/langs';
import Button from '../Button';

const LandingLayout = ({ setPage }) => {
    const {
        state: {
            options: { language },
        },
    } = useContext(GlobalContext);
    const { landing } = langs[language];
    
    return (
        <div className="mth-calc-layout landingPage-layout">
            <div className="content-section">
                <div className="content-col landingPage">                    
                        <h3>{landing.newTitle}</h3>
                        <p className="ft-sz-sml textArea">{landing.newText}</p>
                        <Button 
                            text={landing.newButton}
                            onClick={() => {
                                setPage('step1');
                            }}
                        />
                </div>
            </div>
            <div className="content-section">
                <div className="content-col landingPage">
                        <h3>{landing.returningTitle}</h3>
                        <p className="ft-sz-sml textArea">{landing.returningText}</p><Button
                        text={landing.returningButton} 
                        onClick={() => {
                            setPage('returningUser');
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default LandingLayout;